import React, { useState } from 'react';

import { TextField, Button, Grid, Box, Container, Paper, Stack } from '@mui/material';

import LinearProgress from '@mui/material/LinearProgress';

// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import dayjs, { Dayjs } from 'dayjs';

import AdherentService from "../services/adherent-service";
import Adherent from '../domain/Adherent';

import AdherentList from './AdherentList';
import ErrorDialog from './ErrorDialog';
//import Header  from './Header'

import InstructionSection from './InstructionSection';

import HttpError from './HttpError';
// import DateInput from './DateInput';

import { isNumeric, isValidName } from "../utils";

type Field = {
    value?: any,
    error?: string,
    isValid?: boolean
};

type Form = {
    numParticulier: Field,
    nom: Field,
    prenom: Field,
    dateNaissance: Field
    //dateNaissance: Dayjs | null
}

const Search: React.FC = () => {

    const [form, setForm] = useState<Form>({
        numParticulier: { value: "", error: "", isValid: true  },
        nom: { value: "", error: "", isValid: true  },
        prenom: { value: "", error: "", isValid: true  },
        dateNaissance: { value: "", error: "", isValid: true  },
    });

    const [adherents, setAdherents] = useState<Adherent[] | null>(null);

    const [submitRequest, setSubmitRequest] = useState(false);
    const [loading, setLoading] = useState(false);

    const [errorMessage, setErrorMessage] = useState<string>("");
    const [showErrorDialog, setShowErrorDialog] = useState(false);

    const adherentService = new AdherentService();

    const onChangeNumParticulier = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement>): void => {
        if(isNumeric(e.target.value)){
            setForm({
                ...form,
                numParticulier: { value: e.target.value, error: "", isValid: true },
                nom: { value: "", error: "", isValid: true },
                prenom: { value: "", error: "", isValid: true },
                dateNaissance: { value: "", error: "", isValid: true },
            });
        }
    };

    const onChangeNom = (e: React.ChangeEvent<HTMLInputElement>) => {
        if(isValidName(e.target.value)){
            setForm({
                ...form,
                numParticulier: { value: "", error: "", isValid: true },
                nom: { value: e.target.value, error: "", isValid: true },
            });
        }
    };

    const onChangePrenom = (e: React.ChangeEvent<HTMLInputElement>) => {
        if(isValidName(e.target.value)){
            setForm({
                ...form,
                numParticulier: { value: "", error: "", isValid: true },
                prenom: { value: e.target.value, error: "", isValid: true },
            });
        }
    };

    const onChangeDateNaissance = (e: React.ChangeEvent<HTMLInputElement>): void => {

        let value = e.target.value;

        // Supprimer tout ce qui n'est pas un chiffre
        value = value.replace(/\D/g, '');

        // Formater en JJ/MM/YYYY
        if (value.length >= 2) {
            value = value.slice(0, 2) + '/' + value.slice(2);
        }
        if (value.length >= 5) {
            value = value.slice(0, 5) + '/' + value.slice(5, 9);
        }

        // Limiter à 10 caractères (JJ/MM/YYYY)
        if (value.length > 10) {
            value = value.slice(0, 10);
        }

        setForm({
            ...form,
            numParticulier: { value: "", isValid: true },
            dateNaissance: { value: value, isValid: true },
        });
    };

     // Gérer les touches autorisées (uniquement les chiffres, backspace, et tabulation)
     const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>): void => {
        const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
        if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
            e.preventDefault();
        }
    };

    const reset = () => {
        resetForm();
        setAdherents(null);
        setLoading(false);
        setSubmitRequest(false);
    }

    const resetForm = () => {
        setForm({ 
            numParticulier: { value: "", error: "", isValid: true },  
            nom: { value: "", error: "", isValid: true }, 
            prenom: { value: "", error: "", isValid: true }, 
            dateNaissance: { value: "", error: "", isValid: true }
        });
    }

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        //setAdherents(null);
        let isValid =  validation();
        if(isValid === true){
            setLoading(true);
            search();
        }
    }

    const validation = (): boolean => {

        let isValid = true;
        const newForm = { ...form };

        // Si tous les champs sont vides
        if (
            !form.numParticulier.value &&
            !form.nom.value &&
            !form.prenom.value &&
            !form.dateNaissance.value
        ) {
            newForm.numParticulier.isValid = false;
            newForm.nom.isValid = false;
            newForm.prenom.isValid = false;
            newForm.dateNaissance.isValid = false;
            isValid = false;
        }

        // Validation
        if (form.numParticulier.value) {
            newForm.numParticulier.isValid = true;
            newForm.nom.isValid = true;
            newForm.prenom.isValid = true;
            newForm.dateNaissance.isValid = true;
        } else {
            // Validation nom, prenom, and dateNaissance
            if (!form.nom.value) {
                newForm.nom.isValid = false;
                isValid = false;
            } else {
                newForm.nom.isValid = true;
            }

            if (!form.prenom.value) {
                newForm.prenom.isValid = false;
                isValid = false;
            } else {
                newForm.prenom.isValid = true;
            }
            
            if (!form.dateNaissance.value) {
                newForm.dateNaissance.isValid = false;
                isValid = false;
            } else {
                newForm.dateNaissance.isValid = true;
            }
        }

        setForm(newForm);
        
        return isValid;
    };

    const search = async() => {
        try{

            let numParticulier = form.numParticulier.value;
            let nom = form.nom.value;
            let prenom = form.prenom.value;
            let dateNaissance = form.dateNaissance.value;

            setSubmitRequest(true);

            if(numParticulier){
                const adherentData = await adherentService.getAdherentByNumParticulier(numParticulier);
                if(adherentData){
                    setAdherents(adherentData);
                    setLoading(false);
                    setSubmitRequest(false);
                }
            } else if(nom && prenom && dateNaissance){
                const adherentData = await adherentService.getAdherentByNomPrenomDateNaissance(nom, prenom, dateNaissance);
                if(adherentData){
                    setAdherents(adherentData);
                    setLoading(false);
                    setSubmitRequest(false);
                }
            }

        }catch(error: any){

            setAdherents(null);
            setLoading(false);

            //console.log("error = " + JSON.stringify(error, null, 2));

            if (error instanceof HttpError) {
                // Gestion des erreurs HTTP
                if (error.statusCode === 404) {
                    //On affichera le tableau vide
                    setSubmitRequest(true);
                } else if (error.statusCode >= 400 && error.statusCode < 600) {
                    // Erreurs 4xx et 5xx : Ouvrir une boîte de dialogue
                    setErrorMessage(`${error.message}`);
                    setShowErrorDialog(true);
                    setSubmitRequest(false);
                } else {
                    // Erreurs non spécifiques (ex: réseau)
                    setErrorMessage("Une erreur s'est produite. Veuillez réessayer plus tard.");
                    setShowErrorDialog(true);
                    setSubmitRequest(false);
                }
            }
        }
    }

    return (

        <React.Fragment>

           
            <InstructionSection />

            <Container
                maxWidth="lg" // Limite la largeur du formulaire, lg, md
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '50vh', // Centre verticalement le formulaire
                    paddingTop: 2
                }}
                >
                
                <Stack
                    direction="column"
                    spacing={2}
                    alignItems="center"
                    sx={{ minHeight: '100vh' }}
                    >

                    <form onSubmit={handleSubmit}>

                        <Paper elevation={3} sx={{ paddingTop:2, paddingBottom:2, paddingLeft:3, paddingRight:3 }}>
                            <Box
                                sx={{
                                    '& .MuiTextField-root': { m: 0.5, width: '100%' },
                                    '& .MuiButton-root': { m: 1 },
                                }}
                            >

                                <Grid container spacing={1}>

                                    {/* Première ligne */}
                                    <Grid item xs={12}>
                                        <TextField
                                            name='numParticulier'
                                            label="N° de particulier CSF"
                                            variant="outlined"
                                            value={form.numParticulier.value}
                                            onChange={onChangeNumParticulier}
                                            error={form.numParticulier.isValid === false}
                                            inputProps={{ maxLength: 255 }}
                                            fullWidth
                                            size="small"
                                        />
                                    </Grid>

                                    {/* Deuxième ligne */}
                                    <Grid item xs={4}>
                                        <TextField
                                            name='nom'
                                            label="Nom"
                                            variant="outlined"
                                            value={form.nom.value}
                                            onChange={onChangeNom}
                                            error={form.nom.isValid === false}
                                            inputProps={{ maxLength: 255 }}
                                            fullWidth
                                            size="small"
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField
                                            name='prenom'
                                            label="Prénom"
                                            variant="outlined"
                                            value={form.prenom.value}
                                            onChange={onChangePrenom}
                                            error={form.prenom.isValid === false}
                                            inputProps={{ maxLength: 255 }}
                                            fullWidth
                                            size="small"
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField
                                            name='dateNaissance'
                                            label="Date de naisance"
                                            value={form.dateNaissance.value}
                                            onChange={onChangeDateNaissance}
                                            onKeyDown={handleKeyDown}
                                            placeholder="JJ/MM/YYYY"
                                            error={form.dateNaissance.isValid === false}
                                            inputProps={{ maxLength: 10 }}
                                            size="small"
                                            />

                                    </Grid>

                                    <Grid item xs={12} sx={{ textAlign: 'right' }}>
                                        <Button variant="contained" color="primary" type="submit">
                                            Rechercher
                                        </Button>
                                        <Button variant="outlined" color="secondary" onClick={reset}>
                                            Réinitialiser
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Paper>

                        <Grid>
                            { loading && (
                                <LinearProgress />
                            )}
                        </Grid>

                    </form>

                    <AdherentList adherents={adherents} submitRequest={submitRequest} loading={loading} />

                </Stack>

                {showErrorDialog && (
                    <ErrorDialog 
                        title='Erreur' 
                        message={errorMessage}
                        showErrorDialog={showErrorDialog} 
                        setShowErrorDialog={setShowErrorDialog} />
                )}

            </Container>

        </React.Fragment>
        
    )

}

export default Search;